@if (searchService.search_loading || showOverride) {
  <app-loading-screen icon="ico-bed" [animated]="animated">
    <span title i18n="@@hotelLoading_title">Just loading your search results</span>
    <div msgOne i18n="@@hotelLoading_msgOne">
      {{ getLoadingMessage() }}
    </div>
    <span msgTwo i18n="@@hotelLoading_msgTqo">Checking for availability</span>
  </app-loading-screen>
}
